module.exports = __webpack_public_path__ + "assets/img/7.19a01636.png";